export const CLAIM_LIST_URL_PARAM_KEYS = [
  'search',
  'page',
  'pageSize',
  'sort',
  'claimStatus',
  'appType',
  'createdFrom',
  'createdTo',
];

export const DEFAULT_CLAIM_LIST_EXTRA_FILTERS = {
  selectedFileStatus: [],
  selectedAppType: [],
  selectedLeaseDate: {
    startDate: null,
    endDate: null,
  },
};

export const parseClaimsFilters = (searchParams, _paramKey, fallback) => ({
  claimStatus: searchParams.get('claimStatus')
    ? searchParams.get('claimStatus').split(',').filter(Boolean)
    : fallback.selectedFileStatus,
  appType: searchParams.get('appType')
    ? searchParams.get('appType').split(',').filter(Boolean)
    : fallback.selectedAppType,
  createdFrom: searchParams.get('createdFrom') || fallback.selectedLeaseDate?.startDate || null,
  createdTo: searchParams.get('createdTo') || fallback.selectedLeaseDate?.endDate || null,
});

export const parseClaimsExtraFilters = (searchParams, paramKey, fallback) => {
  const parsed = parseClaimsFilters(searchParams, paramKey, fallback);
  return {
    selectedFileStatus: parsed.claimStatus,
    selectedAppType: parsed.appType,
    selectedLeaseDate: {
      startDate: parsed.createdFrom,
      endDate: parsed.createdTo,
    },
  };
};

export const serializeClaimsFilters = (filters) => ({
  claimStatus:
    Array.isArray(filters.selectedFileStatus) && filters.selectedFileStatus.length > 0
      ? filters.selectedFileStatus.join(',')
      : '',
  appType:
    Array.isArray(filters.selectedAppType) && filters.selectedAppType.length > 0
      ? filters.selectedAppType.join(',')
      : '',
  createdFrom: filters.selectedLeaseDate?.startDate || '',
  createdTo: filters.selectedLeaseDate?.endDate || '',
});

export const areArraysEqual = (a = [], b = []) =>
  a.length === b.length && a.every((value, index) => value === b[index]);

export const areDateRangesEqual = (a = {}, b = {}) =>
  (a?.startDate || null) === (b?.startDate || null) &&
  (a?.endDate || null) === (b?.endDate || null);

export const normalizeArrayFilter = (value) => (Array.isArray(value) ? value : []);

export const normalizeDateRangeFilter = (value) => ({
  startDate: value?.startDate || null,
  endDate: value?.endDate || null,
});
